module.exports = __webpack_public_path__ + "static/media/icoNotedIcon-Holding@2x.d65e5010.png";